<fl-document-viewer *ngIf="documentService.document" [document]="documentService.document">
</fl-document-viewer>
